export class Test
{
	testId: number;
	testDate: Date;
}
